import {Buffer} from 'buffer';

import request from '../api/requests/request';

export const sliceString = (str: string, count = 1, separator = ' ') =>
  str.split(separator).reverse().slice(count).reverse().join(separator);

type Identifiable = {
  id: string;
};

export const findIndex = (
  items?: Partial<Identifiable>[],
  item?: Partial<Identifiable>
): number => {
  if (!items || !item) {
    return -1;
  }

  const {id: itemId} = item;

  const index = items.findIndex(({id}) => id === itemId);

  return index;
};

export const uploadImage = async (image: File) => {
  const imageForm = new FormData();

  const filename = image.name;
  const [ext] = [...filename.split('.')].reverse();

  imageForm.append('file', image);
  imageForm.append('filename', filename);
  imageForm.append('contentType', ext);

  const uploadedImage = await request('/image', {
    method: 'POST',
    headers: {ContentType: 'multipart/form-data'},
    data: imageForm,
  });

  return uploadedImage.id;
};

export const downloadImage = async (id?: string) => {
  if (!id) {
    return;
  }

  try {
    const response = await request(
      `/image/${id}/download`,
      {
        responseType: 'arraybuffer',
      },
      true
    );

    const image = new Buffer(response.data, 'binary').toString('base64');

    const mimetype = response.headers['content-type'].toLowerCase();

    return `data:${mimetype};base64,${image}`;
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  } catch (error: any) {
    console.error('Failed to download the image', error);
    return;
  }
};

export const deleteImage = async (imageId: string, imageUrl?: string) => {
  try {
    await request(`/image/${imageId}`, {
      method: 'DELETE',
    });

    if (imageUrl) {
      URL.revokeObjectURL(imageUrl);
    }
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  } catch (error: any) {
    console.log('Failed to delete the image', error);
  }
};

export const findQuery = (search: string, keyword?: string) => {
  const queries = new URLSearchParams(search);

  if (keyword) {
    return queries.get(keyword);
  }

  return search;
};

export const addHttp = (url: string) => {
  if (!url.includes('http://') && !url.includes('https://')) {
    return `http://${url}`;
  }
  return url;
};

export const replaceWithHttps = (url: string) =>
  url.replace('http://', 'https://');
